const state = {
  //@ts-ignore
  fields: JSON.parse(localStorage.getItem("fields")) || {},
}

export default {
  ...state,
}
